module.exports = __webpack_public_path__ + "img/download-icon.e7fac4bc.svg";